import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { BlockUIModule } from 'ng-block-ui';
import { B2BAngularMaterialModule } from '../../components/common/angular.material/b2b.angular.material.module';
import { CategoryTreeViewModule } from '../../components/common/category.tree.view/category.tree.view.module';
import { PagingModule } from '../../components/common/search/paging.module';
import { ValidationModule } from '../../components/common/validation/validation.module';
import { EnumSelectPipeModule } from '../../components/pipes/enumselectpipe/enumSelectPipe.module';
import { SafeHtmlPipeModule } from '../../components/pipes/safehtml.pipe/safe.html.pipe.module';
import { ResourcesComponent } from './resources.component';

@NgModule({
    declarations: [ResourcesComponent],
    imports: [BrowserModule, FormsModule, ReactiveFormsModule, RouterModule, PagingModule, ValidationModule, B2BAngularMaterialModule, CategoryTreeViewModule, BlockUIModule, EnumSelectPipeModule, SafeHtmlPipeModule]
})

export class ResourcesModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/resources/resources.module.ts